import { Box, Heading, Stack } from '@chakra-ui/react'

// One titled block of the user page, drawn like the event overview's.
export function UserSection({ id, title, children, tone }) {
    return (
        <Box as="section" aria-labelledby={id}>
            <Heading id={id} as="h2" size="md" mb={3}>{title}</Heading>
            <Stack
                gap={4}
                p={4}
                border="1px solid"
                borderColor={tone === 'danger' ? 'var(--mc-red)' : 'var(--mc-border)'}
                borderRadius="lg"
                bg="var(--mc-bg-surface)"
            >
                {children}
            </Stack>
        </Box>
    )
}
